import type { MaybeRef } from "vue";

import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

import kiliApi from "@/api/kili/kili-api.ts";
import { KiliOrganizationsQueryKeys } from "@/api/kili/organizations/kili-organizations-query-keys.ts";

export function kiliOrganizationDetailsOptions(organizationId: MaybeRef<number>) {
  const _organizationId = toValue(organizationId);

  return queryOptions({
    queryKey: KiliOrganizationsQueryKeys.detail(_organizationId),
    queryFn: () => kiliApi.findOrganizationById({ params: { organizationId: _organizationId } }),
    meta: { updatesRouteTitle: true },
  });
}

export function useKiliOrganizationDetailsQuery(organizationId: MaybeRef<number>) {
  return useQuery(kiliOrganizationDetailsOptions(organizationId));
}
